import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import ProfileHeader from '../../../components/ProfileHeader'
import Box from '@mui/material/Box'
import { Trans } from 'react-i18next'
import { getSessionStorage } from '../../../utils/StorageUtil'
import { TOKEN_SO_KEY } from '../../../utils/accountUtils'
import ProfileBottomNav from '../../../components/ProfileBottomNav'
import UnitsApi from '../../../api/UnitsApi'
import Grid from '@mui/material/Grid'
import Card from '@mui/material/Card'
import UserDataApi from '../../../api/UserDataApi'
import IncludedChargesApi from '../../../api/IncludedChargesApi'
import moment from 'moment/moment'
import Container from '@mui/material/Container'
import Close from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'
import { currencyFormat } from '../../../utils/generalUtils'
import { getContractChecklist, printChecklist } from '../../../api/ChecklistApi'
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import { PrintOutlined } from '@mui/icons-material'

function ColumnItem(props: {
  label: string
  info: string
  isCurrency?: boolean
}) {
  return (
    <Grid item xs={6} md={4} mb={2} className="info-static-row">
      <div className="info-static-label">{props.label}</div>
      <Box textAlign={props.isCurrency ? 'right' : 'left'}>
        {props.info || '-'}
      </Box>
    </Grid>
  )
}

const Unit = () => {
  const { domain } = useParams()
  const [unit, setUnit] = useState<any>({})
  const [users, setUsers] = useState<any>({})
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()

  useEffect(() => {
    if (domain) {
      getUnit(domain)
    }
  }, [domain])

  useEffect(() => {
    if (unit?.checklist) {
      getChecklistUsers(unit?.checklist)
    }
  }, [unit?.checklist])

  const getUnit = function (domain: string) {
    if (domain)
      UnitsApi.get(domain)
        .then(async (resp) => {
          let oUnit = { ...resp?.data }
          if (oUnit?.contract?.managerUserID) {
            await UserDataApi.get(oUnit.contract.managerUserID).then(
              (respManager) => {
                oUnit.manager = respManager?.data
              }
            )
          }
          if (
            oUnit?.contract?.includedValue !== '' ||
            oUnit?.contract?.includedValueHS !== ''
          ) {
            await IncludedChargesApi.getByIds(
              [
                oUnit.contract?.includedValue,
                oUnit.contract?.includedValueHS,
              ].filter((ci) => ci !== '' && ci !== null)
            ).then((respIC) => {
              oUnit.km = respIC?.data.find((c) => c.unity === 'KM')?.name
              oUnit.hs = respIC?.data.find((c) => c.unity === 'HS')?.name
            })
          }
          await getContractChecklist(oUnit?.contract?.id).then((ck) => {
            oUnit.checklist = ck?.data
          })
          setUnit(oUnit)
          setLoading(false)
        })
        .catch(() => setLoading(false))
  }

  const getChecklistUsers = function (checklists: any) {
    const usrIds = checklists.map(c => c.userID);
    if(usrIds.length > 0) {
      UserDataApi.getUsers(usrIds)
        .then((respUsers) => {
          if(respUsers?.data){
            let oNames = {}
            respUsers?.data.forEach(u => { oNames = {...oNames, [u.id]: `${u.lastName}, ${u.firstName}`}});
            setUsers(oNames);
          }
        })
    }
  }

  const handleClose = () => {
    navigate(-1)
  }

  function getDayRate(dailyChargeRate: any, unitPrice: any) {
    const result = unitPrice / dailyChargeRate
    if (isFinite(result)) return result.toFixed(2)
    else return 0
  }

  const handlePrint = (idCheck: any) => {
    if (idCheck) {
      printChecklist(idCheck)
        .then()
        .catch((e) => {
          console.log('Error', e)
        })
    }
  }
  const contract = unit?.contract
  return (
    <Box>
      <ProfileHeader></ProfileHeader>
      <Box />
      <Box sx={{ maxWidth: '572px', margin: 'auto' }}>
        <Box className="unit-detail-title">
          <Trans i18nKey={`screens.unitDetail.title`}></Trans>
        </Box>
      </Box>
      <Container
        maxWidth="md"
        sx={{ position: 'relative', marginBottom: '3em' }}
      >
        {loading ? (
          <Card>
            <Box p={3}>Cargando...</Box>
          </Card>
        ) : (
          <>
            <IconButton
              onClick={handleClose}
              size="small"
              className="search-vehicles-icon-button unit-detail-floating-button"
              sx={{
                right: '50px',
                top: '20px',
              }}
            >
              <Close />
            </IconButton>
            <Card>
              <Box pt={3} className="unit-detail-number-plate">{domain}</Box>
              <Box className="unit-detail-car-classification">
                {unit?.unitType?.model ?? "-"}
              </Box>
              <Box className="unit-detail-model">{`${unit?.unitType?.brand} - ${unit?.unitType?.model} - ${unit?.color} `}</Box>
              <Grid container p={6}>
                <Grid item container mb={3}>
                  <Grid
                    item
                    xs={6}
                    sm={10}
                    className="unit-detail-car-classification"
                    textAlign="left"
                  >
                    Nro. de Contrato {contract?.idContract}{' '}
                  </Grid>
                  <Grid item xs={6} sm={2}>
                    <Box textAlign="center" className="status-box-def">
                      <Trans
                        i18nKey={`models.contractStatus.labels.${contract?.status}`}
                      />
                    </Box>
                  </Grid>
                </Grid>
                <Grid item container xs={12} className="info-static-title-line">
                  <Grid xs={3} sm={2} item>
                    Locatario
                  </Grid>
                  <Grid xs={9} sm={10} item>
                    <hr />
                  </Grid>
                </Grid>
                <Grid container item md={12} className="data-static">
                  <ColumnItem label="Cliente" info={contract?.company?.name} />
                  <ColumnItem label="CUIT" info={contract?.company?.cuit} />
                </Grid>
                <Grid container item md={12}>
                  <ColumnItem
                    label="Dirección"
                    info={contract?.company?.streetAddress}
                  />
                  <ColumnItem
                    label="Provincia"
                    info={`${contract?.company?.province}`}
                  />
                </Grid>
                <Grid container item md={12}>
                  <ColumnItem
                    label="Nº Cotización"
                    info={contract?.quotation?.idQuotation}
                  />
                </Grid>
                <Grid container item md={12}>
                  <ColumnItem
                    label="Responsable certificador"
                    info={`${unit?.manager?.firstName} ${unit?.manager?.lastName}`}
                  />
                  <ColumnItem
                    label="DNI o Pasaporte"
                    info={unit?.manager?.dni}
                  />
                </Grid>
                <Grid container item md={12}>
                  <ColumnItem label="Conductor" info={contract?.driverName} />
                  <ColumnItem
                    label="DNI o Pasaporte"
                    info={contract?.driverNumber}
                  />
                  <ColumnItem label="Licencia" info={contract?.driverLicense} />
                </Grid>

                <Grid item container xs={12} className="info-static-title-line">
                  <Grid xs={5} sm={3} item>
                    Tipo de alquiler
                  </Grid>
                  <Grid xs={7} sm={9} item>
                    <hr />
                  </Grid>
                </Grid>
                <Grid container item md={12}>
                  <ColumnItem label="Tipo" info={contract?.rentalType?.name} />
                  <ColumnItem
                    label="Método de actualización"
                    info={contract?.method?.name}
                  />
                  <ColumnItem label="Moneda" info={contract?.currency} />
                </Grid>
                <Grid container item md={12}>
                  <ColumnItem
                    label="Fecha de entrega pactada"
                    info={
                      contract?.returnDate
                        ? moment(contract?.returnDate).format('DD-MM-YYYY')
                        : '-'
                    }
                  />
                  <ColumnItem
                    label="Fecha de entrega"
                    info={
                      contract?.initDate
                        ? moment(contract?.initDate).format('DD-MM-YYYY')
                        : '-'
                    }
                  />
                </Grid>
                <Grid container item md={12}>
                  <ColumnItem
                    label="Fecha de devolución pactada"
                    info={
                      contract?.deliveryDate
                        ? moment(contract?.deliveryDate).format('DD-MM-YYYY')
                        : '-'
                    }
                  />
                  <ColumnItem
                    label="Fecha de devolución"
                    info={
                      contract?.dueDate
                        ? moment(contract?.dueDate).format('DD-MM-YYYY')
                        : '-'
                    }
                  />
                </Grid>

                <Grid item container xs={12} className="info-static-title-line">
                  <Grid xs={3} sm={2} item>
                    Equipo
                  </Grid>
                  <Grid xs={9} sm={10} item>
                    <hr />
                  </Grid>
                </Grid>
                <Grid container item md={12}>
                  <ColumnItem label="Dominio" info={unit?.numberPlate} />
                  <ColumnItem label="Modelo" info={unit?.unitType?.model} />
                </Grid>
                <Grid container item md={12}>
                  <ColumnItem label="Color" info={unit?.color} />
                  <ColumnItem
                    label="Caracterización"
                    info={contract?.rate?.characterisation?.name}
                  />
                </Grid>
                <Grid container item md={12}>
                  <ColumnItem label="N° Chasis " info={unit?.chassisID} />
                  <ColumnItem label="N° Motor" info={unit?.engineID} />
                </Grid>

                <Grid item container xs={12} className="info-static-title-line">
                  <Grid xs={6} sm={3} item>
                    Tarifas e incluidos
                  </Grid>
                  <Grid xs={6} sm={9} item>
                    <hr />
                  </Grid>
                </Grid>
                <Grid container item md={12} spacing={2}>
                  <ColumnItem label="Km Incluídos" info={unit?.km} />
                  <ColumnItem
                    label="Km Limitadas"
                    info={contract?.limitedValue}
                  />
                  <ColumnItem
                    label="Cargos km excedentes "
                    info={currencyFormat(contract?.surplusRate)}
                    isCurrency={true}
                  />
                </Grid>
                <Grid container item md={12} spacing={2}>
                  <ColumnItem label="Hs Incluídas" info={unit?.hs} />
                  <ColumnItem
                    label="Hs Limitadas"
                    info={contract?.limitedValueHS}
                  />
                  <ColumnItem
                    label="Cargos hs excedentes "
                    info={currencyFormat(contract?.surplusRateHS)}
                    isCurrency={true}
                  />
                </Grid>
                <Grid container item md={12} spacing={2}>
                  <ColumnItem
                    label="Cargos diarios ($ x Dia)"
                    info={currencyFormat(
                      getDayRate(
                        contract?.rentalType?.dailyChargeRate,
                        contract?.unitPrice
                      )
                    )}
                    isCurrency={true}
                  />
                  <Grid item xs={6} md={4} mb={2} className="info-static-row">
                    <div className="info-static-label">Tipo de seguro</div>
                    <div>
                      <Trans
                        i18nKey={`models.insuranceType.labels.${contract?.assuranceType}`}
                      />
                    </div>
                  </Grid>

                  <ColumnItem
                    label="Cargo Seguro"
                    info={currencyFormat(contract?.assurancePrice)}
                    isCurrency={true}
                  />
                </Grid>
                <Grid container item md={12} spacing={2}>
                  <ColumnItem
                    label="Importe inicial total s/IVA:"
                    info={currencyFormat(contract?.finalPrice)}
                    isCurrency={true}
                  />
                </Grid>

                <Grid item container xs={12} className="info-static-title-line">
                  <Grid xs={6} sm={3} item>
                    Checklist asociados{' '}
                  </Grid>
                  <Grid xs={6} sm={9} item>
                    <hr />
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Table
                    sx={{ minWidth: 650 }}
                    aria-label="checklist"
                    size="small"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>Nro</TableCell>
                        <TableCell>Tipo</TableCell>
                        <TableCell>Fecha</TableCell>
                        <TableCell>Estado</TableCell>
                        <TableCell>Entrega</TableCell>
                        <TableCell>Recibe</TableCell>
                        <TableCell>Ver</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {unit?.checklist &&
                        unit?.checklist.length > 0 &&
                        unit?.checklist?.map((ck) => (
                          <TableRow
                            key={ck.idCheckList}
                            sx={{
                              '&:last-child td, &:last-child th': { border: 0 },
                            }}
                          >
                            <TableCell component="th" scope="row">
                              {ck.idCheckList}
                            </TableCell>
                            <TableCell>{ck.template?.name}</TableCell>
                            <TableCell>
                              {moment(ck.creationDate).format('DD-MM-YYYY')}
                            </TableCell>
                            <TableCell>{ck.status}</TableCell>
                            <TableCell>{ck.operatorName}</TableCell>
                            <TableCell>{users && users?.[ck.userID]}</TableCell>
                            <TableCell>
                              {ck.status === 'FINALIZADO' && (
                                <IconButton onClick={() => handlePrint(ck.id)}>
                                  <PrintOutlined />
                                </IconButton>
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </Grid>
                <Grid item container xs={12} className="info-static-title-line">
                  <Grid xs={6} sm={4} item>
                    Condiciones de Alquiler
                  </Grid>
                  <Grid xs={6} sm={8} item>
                    <hr />
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  {contract?.conditions.map((cc) => (
                    <Box key={cc.id} mb={2}>
                      {cc.condition.name}
                    </Box>
                  ))}
                </Grid>
              </Grid>
            </Card>
          </>
        )}
      </Container>
      {getSessionStorage(TOKEN_SO_KEY) !== null && (
        <ProfileBottomNav goBack={true}></ProfileBottomNav>
      )}
    </Box>
  )
}

export default Unit
